<template>
  <div v-if="meta.total > 0 || !meta.keyword">
    <div class="content-wrap">
      <div class="item-wrap" v-for="item in imgList" :key="item.picId" :style="{
        width: voteIntroShow ? 'calc((100% - 6px) / 2)' : `${item.width}`,
        marginBottom: voteIntroShow ? '20px' : '10px',
      }">
        <div class="item" @click="$router.push(`/works/${$route.params.type}/${item.id}`)"
          :style="{ height: voteIntroShow ? '129px' : '100%' }">
          <img :src="
            item.recommend === '500px'
              ? item.picUrl
              : `${item.picUrl}?x-oss-process=image/resize,p_10`
          " :alt="item.worksname" />
          <div class="mask">
            <div class="info">
              <h2>{{ item.worksname }}</h2>
              <h3>{{ item.author }}</h3>
            </div>
          </div>
        </div>
        <div v-if="voteIntroShow" class="vote-info">
          <el-checkbox class="vote-check" v-model="item.isChecked" @change="voteChangeEvent($event, item)">{{ item.id |
              fillZero
          }}</el-checkbox>
          <div class="vote-num">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-dianzan"></use>
            </svg><span>{{ item.weekVoteNumber || 0 }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination">
      <van-pagination v-model="meta.currentPage" :items-per-page="meta.pageSize" :total-items="meta.total"
        @change="currentChangeEvent" mode="simple" />
    </div>
  </div>
  <div v-else class="search-fail">
    <div>没有找到你想要的作品, 猜测你想找的是它</div>
    <div v-if="guessData.length > 0" class="guess-item" @click="$router.push(`/works/${$route.params.type}/${guessData[0].id}`)" :style="{
      background: $store.state.env.isIE
        ? guessData[0].recommend === '500px'
          ? guessData[0].picUrl
          : `url(${guessData[0].picUrl}?x-oss-process=image/resize,p_10) no-repeat center`
        : '',
      backgroundSize: $store.state.env.isIE ? `cover` : '',
      width: voteIntroShow
        ? 'calc((100% - 10px) / 2)'
        : `${guessData[0].width}`,
    }">
      <img v-if="!$store.state.env.isIE" :src="
        guessData[0].recommend === '500px'
          ? guessData[0].picUrl
          : `${guessData[0].picUrl}?x-oss-process=image/resize,p_10`
      " :alt="guessData[0].worksname" />
      <div class="mask">
        <div class="info">
          <h2>{{ guessData[0].worksname }}</h2>
          <h3>{{ guessData[0].author }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import worksApi from "@/api/works";

export default {
  name: "WorksListMainMobile",
  data() {
    return {
      imgList: [],
      meta: {
        total: 0,
        pageSize: 20,
        currentPage: 1,
        keyword: ""
      },
      endNum: 0,
      guessData: [],
      picData: [],
      imgArr: [],
      voteIntroShow: true
    };
  },
  computed: {
    ...mapState(["sortActive", "selectedArr", "imgListNum", "searchWorksType"]),
  },
  watch: {
    async endNum(newVal) {
      if (newVal === this.imgListNum && this.imgListNum > 0) {
        let arr = [];
        this.imgArr.forEach((value, index) => {
          arr.push(parseInt(value.picType));
          if (arr.length === 2) {
            if ((arr[0] + arr[1] === 0) || (arr[0] + arr[1] === 2)) {
              this.imgArr[index - 1].width = "calc((100% - 6px) / 2)";
              this.imgArr[index].width = "calc((100% - 6px) / 2)"
            } else {
              this.imgArr[index - 1].width = arr[0] === 0 ? "calc((100% - 6px) * 2 / 3)" : "calc((100% - 6px) * 1 / 3)";
              this.imgArr[index].width = arr[1] === 0 ? "calc((100% - 6px) * 2 / 3)" : "calc((100% - 6px) * 1 / 3)";
            }
            arr = [];
          } else {
            if (this.imgArr.length % 2 > 0 && index === this.imgArr.length - 1) {
              this.imgArr[index].width = "calc((100% - 6px) / 2)";
              arr = [];
            }
          }
        })
        this.endNum = 0;
        this.imgArr.forEach(value => this.imgList.push(value));
        // console.log(this.imgList.length)
        if (this.picData.length > 0) {
          await worksApi.updatePicType(this.picData);
        }
        this.picData = [];
      }
    },
  },
  filters: {
    fillZero(num, length = 5) {
      for (var len = (num + "").length; len < length; len = num.length) {
        num = "0" + num;
      }
      return num;
    }
  },
  methods: {
    ...mapMutations(["setBreadcrumb", "setSelectedArr", "radioText"]),
    /**
     * 获取数据
     */
    async fetchData(type = false) {
      let that = this
      if (type && this.meta.currentPage !== 1) {
        this.meta.currentPage = 1;
        this.$router.push({
          path: `/works/${that.$route.params.type}`,
          query: {
            currentPage: this.meta.currentPage,
            keyword: this.meta.keyword || ""
          }
        });
        return;
      }
      let data = await worksApi.fetchWorksList({
        page: this.meta.currentPage,
        keyword: this.meta.keyword,
        sort: this.sortActive,
        type: this.searchWorksType,
        hodingTime: '2022'
      });
      this.imgArr.splice(0, this.imgArr.length);
      this.imgList.splice(0, this.imgList.length);
      if (data.code === 200) {
        // const tempArr = [];
        // data.data.forEach(v => tempArr.push({ ...v, picUrl: v.picUrl.replace("!p6", "!p5") }));
        // data.data = JSON.parse(JSON.stringify(tempArr));
        if (data.meta.searchIsNull === 1) {
          this.getGuessData(data);
        } else {
          if (!this.voteIntroShow) {
            const vm = this;
            vm.$store.commit("setImgListNum", data.data.length);
            for (let i = 0; i < data.data.length; i++) {
              if (data.data[i].picType === null) {
                let img = new Image();
                img.src = data.data[i].recommend === '500px' ? `https://images.weserv.nl/?url=${data.data[i].picUrl}&w=10&fit=inside` : data.data[i].picUrl + "?x-oss-process=image/resize,p_10,w_5";
                img.onload = function () {
                  let flag = vm.selectedArr.indexOf(data.data[i].id);
                  vm.imgArr.splice(i, 0, {
                    ...data.data[i],
                    picUrl: data.data[i].recommend === '500px' ? `https://images.weserv.nl/?url=${data.data[i].picUrl}&w=300&fit=inside` : data.data[i].picUrl,
                    picType: img.width >= img.height ? "0" : "1",
                    width: img.width >= img.height ? "64%" : "%32",
                    isChecked: flag > -1 ? true : false
                  });
                  vm.picData.push({ picId: data.data[i].picId, picType: img.width >= img.height ? "0" : "1" });
                  vm.endNum++;
                }
              } else {
                let flag = this.selectedArr.indexOf(data.data[i].id);
                vm.imgArr.splice(i, 0, {
                  ...data.data[i],
                  picUrl: data.data[i].recommend === '500px' ? `https://images.weserv.nl/?url=${data.data[i].picUrl}&w=300&fit=inside` : data.data[i].picUrl,
                  width: data.data[i].picType === "0" ? "64%" : "32%",
                  isChecked: flag > -1 ? true : false
                });
                vm.endNum++;
              }
            }
          } else {
            this.imgList = data.data.map(i => {
              let flag = this.selectedArr.indexOf(i.id);
              return {
                ...i,
                picUrl: i.recommend === '500px' ? `https://images.weserv.nl/?url=${i.picUrl}&w=300&fit=inside` : i.picUrl,
                isChecked: flag > -1 ? true : false
              };
            });
          }
          this.meta = {
            total: data.meta.total,
            pageSize: data.meta.limit,
            currentPage: data.meta.page,
            keyword: data.meta.name
          };
        }


      }
    },

    /**
 * 猜测的作品
 */
    async getGuessData(guessData) {
      const vm = this;
      vm.guessData = [];
      vm.meta.total = 0;
      if (guessData.data && guessData.data.length > 0) {
        if (!this.voteIntroShow) {
          if (guessData.data[0].picType === null) {
            let img = new Image();
            img.src = guessData.data[0].recommend === '500px' ? `https://images.weserv.nl/?url=${guessData.data[0].picUrl}&w=10&fit=inside` : guessData.data[0].picUrl + "?x-oss-process=image/resize,p_10,w_5";
            img.onload = function () {
              vm.guessData.push({
                ...guessData.data[0],
                picUrl: guessData.data[0].recommend === '500px' ? `https://images.weserv.nl/?url=${guessData.data[0].picUrl}&w=300&fit=inside` : guessData.data[0].picUrl,
                picType: img.width >= img.height ? "0" : "1",
                width: img.width >= img.height ? "64" : "32%",
              });
            }
          } else {
            vm.guessData.push({
              ...guessData.data[0],
              picUrl: guessData.data[0].recommend === '500px' ? `https://images.weserv.nl/?url=${guessData.data[0].picUrl}&w=300&fit=inside` : guessData.data[0].picUrl,
              width: guessData.data[0].picType === "0" ? "64%" : "32%",
            });
          }
        } else {
          vm.guessData.push({ ...guessData.data[0], picUrl: guessData.data[0].recommend === '500px' ? `https://images.weserv.nl/?url=${guessData.data[0].picUrl}&w=300&fit=inside` : guessData.data[0].picUrl })
        }
      }
    },
    /**
     * 分页改变事件
     */ currentChangeEvent(val) {
      let that = this
      this.meta.currentPage = val;
      this.$router.push({
        path: `/works/${that.$route.params.type}`,
        query: { currentPage: val, keyword: this.meta.keyword || "" }
      });
    },
    /**
     * 选择作品
     */
    voteChangeEvent(status, obj) {
      if (this.selectedArr.length >= 5 && status) {
        setTimeout(() => {
          obj.isChecked = false;
        }, 100);
        this.$toast("您已经选择5副作品啦！");
      } else {
        this.setSelectedArr({ status, value: obj.id });
      }
    },
    /**
     * 清空选择
     */
    clearSelectedFn() {
      this.imgList.forEach((item, index) => {
        if (item.isChecked) {
          item.isChecked = false;
          item.weekVoteNumber++; // 票数加1
        }
      });

      this.setSelectedArr([]);
    }
  },
  created() {
    this.meta = {
      keyword: this.$route.query.keyword || "",
      currentPage: Number(this.$route.query.currentPage) || 1
    };
    this.fetchData();
  }
};
</script>
<style lang="scss" scoped>
.content-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
  padding: 0.693rem 0.4rem 0;
  min-height: 65vmax;

  >div:nth-child(2n + 1) {
    margin-right: 6px;
  }

  .item-wrap {

    // width: 4.5rem;
    .vote-info {
      display: flex;
      margin-top: 0.32rem;
      font-size: 12px;
      color: $color-text-regular;

      .vote-check {
        width: 2.174rem;
      }

      ::v-deep .el-checkbox__label {
        vertical-align: middle;
        color: $color-text-regular;
        font-size: 12px;
      }

      ::v-deep .el-checkbox__inner {
        width: 0.4rem;
        height: 0.4rem;
        border-color: $color-text-regular;

        &::after {
          left: 0.12rem;
          top: 0.05rem;
        }

        &:hover {
          border-color: #ffc15e;
        }
      }

      ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
        background: #ffc15e;
        border-color: #ffc15e;
      }

      ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #ffc15e;
      }

      .vote-num {
        height: 20px;

        svg {
          width: 24px;
          height: 21px;
        }

        span {
          color: $color-text-regular;
          margin-left: 8px;
          vertical-align: 6px;
        }
      }
    }
  }

  .item {
    // height: 3.4rem;
    position: relative;
    border-radius: 4px;
    overflow: hidden;

    // margin-top: 10px;
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      transition: all ease-in-out 0.4s;
    }

    .mask {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 24px;
      width: 100%;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));
      transition: all ease-in-out 0.4s;

      .info {
        width: 100%;
        height: 100%;
        display: flex;
      }

      h2,
      h3 {
        font-size: 12px;
        line-height: 24px;
        color: #ffffff;
      }

      h2 {
        margin-left: 12px;
      }

      h3 {
        margin-left: 3px;
      }
    }

    &:hover .mask {
      opacity: 1;
    }

    &:hover .info {
      transform: translateY(0);
    }

    &:hover>img {
      transform: scale(1.1);
    }
  }
}

.pagination {
  padding: 0.787rem 0.4rem 0.8rem;

  ::v-deep .van-pagination__prev {
    background: $color-bg-gray;
    color: $color-text-regular;
  }

  ::v-deep .van-pagination__next {
    background: $color-primary;
    color: $color-text-reverse;

    &::after {
      border: none;
    }
  }
}

// .search-fail {
//   margin: 50px auto 300px;
//   text-align: center;
//   font-size: 12px;
//   color: $color-text-primary;
// }
.search-fail {
  margin: 35px auto 50px;
  padding-left: 15px;
  padding-right: 15px;
  text-align: center;
  font-size: 12px;
  color: $color-text-primary;

  .guess-item {
    height: 100%;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    margin-top: 35px;
    margin-bottom: 400px;
    text-align: left;

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      transition: all ease-in-out 0.4s;
    }

    .mask {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background: rgba(#000, 0.6);
      transition: all ease-in-out 0.4s;
      opacity: 0;

      .info {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transform: translateY(4%);
        transition: all ease-in-out 0.4s;
      }

      h2,
      h3 {
        color: #ffffff;
      }

      h2 {
        font-size: 16px;
      }

      h3 {
        margin-top: 4px;
        font-size: 14px;
      }
    }

    &:hover .mask {
      opacity: 1;
    }

    &:hover .info {
      transform: translateY(0);
    }

    &:hover>img {
      transform: scale(1.1);
    }
  }
}
</style>